/* eslint-disable import/order */

// TODO: do we actually need either of these ambient imports?
/* eslint-disable import/no-unassigned-import */
import 'core-js/stable'
import 'regenerator-runtime/runtime'
/* eslint-enable import/no-unassigned-import */

import domReady from 'bloody-domready'
import React from 'react'
import ReactDOM from 'react-dom'

// Must come before all our other first-party code to ensure the `@layer` order
// is correct
import '@opallabs/gem/src/gem.css'
import { injectGemColors } from '@opallabs/gem'

// Components
import * as Beacon from './components/beacon/monolith-exports'
import * as Cassini from './components/cassini/monolith-exports'
import * as ContentVersionHistory from './components/content-version-history/monolith-exports'
import * as Hubble from './components/hubble/monolith-exports'
import * as Kuiper from './components/kuiper/monolith-exports'
import * as Lapidary from './components/lapidary/monolith-exports'
import * as LapidaryUnstable from './components/lapidary-unstable/monolith-exports'
import * as Permissions from './components/permissions/monolith-exports'
import * as Photon from './components/photon/monolith-exports'
import * as Satellite from './components/satellite/monolith-exports'

// Data
import * as Api from './data/api'
import * as Higgs from './data/higgs/monolith-exports'
import * as Wormhole from './data/wormhole/monolith-exports'

// Styles
import * as Pulsar from './styles/pulsar/monolith-exports'

// Utility
import * as AdobePDFViewer from './utility/adobe-pdf-viewer/monolith-exports'
import * as Analytics from './utility/analytics/monolith-exports'
import * as BrownDwarf from './utility/brown-dwarf/monolith-exports'
import * as Hooks from './utility/hooks/monolith-exports'
import * as Lambda from './utility/lambda/monolith-exports'
import * as Principles from './utility/principles/monolith-exports'
import * as Quanta from './utility/quanta/monolith-exports'
import * as Routing from './utility/routing/monolith-exports'

// Views
import * as AdminConfiguration from './views/admin-configuration/monolith-exports'
import * as Assignments from './views/assignments/monolith-exports'
import * as BlackHole from './views/black-hole/monolith-exports'
import * as Boards from './views/boards/monolith-exports'
import * as Calendar from './views/calendar/monolith-exports'
import * as Continuum from './views/continuum/monolith-exports'
import * as Darwin from './views/darwin/monolith-exports'
import * as ExAstra from './views/ex-astra/monolith-exports'
import * as InMarketPreview from './views/in-market-preview/monolith-exports'
import * as Integrations from './views/integrations/monolith-exports'
import * as PdfExport from './views/pdf-export/monolith-exports'
import * as Periodic from './views/periodic/monolith-exports'
import * as Plans from './views/plans/monolith-exports'
import * as Plasma from './views/plasma/monolith-exports'
import * as Starchart from './views/starchart/monolith-exports'

import './main.scss'

const Frontend = {
  AdminConfiguration,
  Api,
  Assignments,
  Beacon,
  BlackHole,
  Boards,
  BrownDwarf,
  Calendar,
  Cassini,
  ContentVersionHistory,
  Continuum,
  Darwin,
  ExAstra,
  Higgs,
  Hooks,
  Hubble,
  InMarketPreview,
  Integrations,
  Kuiper,
  Lambda,
  Lapidary,
  LapidaryUnstable,
  PdfExport,
  Periodic,
  Permissions,
  Photon,
  Plans,
  Plasma,
  Principles,
  Pulsar,
  Quanta,
  React,
  ReactDOM,
  Routing,
  Satellite,
  Starchart,
  testFeature: Principles.testFeature,
  Wormhole,
}

// Hotfix hacky stuff for ie11, :-(
if (window && window.NodeList && !NodeList.prototype.forEach) {
  // NOTE: This must be a standard named function in IE v11, please do not change
  NodeList.prototype.forEach = function nodeForEach(callback, thisArg) {
    const ta = thisArg || window
    for (let i = 0; i < this.length; i += 1) {
      callback.call(ta, this[i], i, this)
    }
  }
}

// Polyfills for Element.closest
if (!Element.prototype.matches) {
  Element.prototype.matches =
    Element.prototype.msMatchesSelector ||
    Element.prototype.webkitMatchesSelector
}
if (!Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    var el = this

    do {
      if (Element.prototype.matches.call(el, s)) return el
      el = el.parentElement || el.parentNode
    } while (el !== null && el.nodeType === 1)
    return null
  }
}
/* eslint-enable */

// ie custom Event Polyfill: Unsupported, used in kuiper/Drawer
function CustomEvent(event, params) {
  const args = params || {
    bubbles: false,
    cancelable: false,
    detail: undefined,
  }
  const evt = document.createEvent('CustomEvent')
  evt.initCustomEvent(event, args.bubbles, args.cancelable, args.detail)
  return evt
}

try {
  new Event('test')
} catch {
  Event = CustomEvent // eslint-disable-line
}

window.feature_flags = Principles.makeFeatureSet()

Object.keys(Frontend).forEach(
  (packageName) => (window[packageName] = Frontend[packageName])
)

Frontend.branch = process.env.CIRCLE_BRANCH

const dispatch = Higgs.store.dispatch

dispatch(Wormhole.actions.getToken())

const getUsersInWorkspace = (workspaceId) => {
  dispatch(Wormhole.actions.getUsers(workspaceId))
}

const setCurrentWorkspace = (workspaceId) => {
  dispatch(Wormhole.actions.setCurrentWorkspace(workspaceId))
}

window.dispatch = dispatch
window.getUsersInWorkspace = getUsersInWorkspace
window.setCurrentWorkspace = setCurrentWorkspace

// NOTE(jbragg): This code will be needed when we separate from the backend.
// const externalBrandId = () => window && window.OpalMoments && window.OpalMoments.State
//     && window.OpalMoments.State.current_brand
//     && window.OpalMoments.State.current_brand.id;
// const setInitialWorkspace = () => {
//   if (externalBrandId()) {
//     setCurrentWorkspace(externalBrandId());
//   }
// };
//

const handleEvent = (frameJson) => {
  if (frameJson.data) {
    Wormhole.ReduxUpdateQueue.addItem(frameJson)
  }
}

const connectChannels = (timer = 1000) => {
  if (window.AppBase.data.notification_channels) {
    const opalChannels = window.AppBase.data.notification_channels
    const channels = [opalChannels[0].split('::')[1], ...opalChannels]
    Quanta.info(`Listening to ${channels.length} channels`, channels)

    new Lambda.RelayWebSocket({
      debug: false,
      channels: channels,
      onMessage: handleEvent,
      eventSourceUrl: window.top.location.origin,
    })
    return
  }
  if (timer < 10000) {
    setTimeout(connectChannels.bind(this, timer + 1000), timer)
  }
}

const setupWSListener = () => {
  if (window.AppBase && window.AppBase._initCallbacks) {
    window.AppBase._initCallbacks.add(() => {
      setTimeout(connectChannels, 1000)
    })
  }
}

const initAnalytics = () => {
  if (window.userAnalytics) {
    Quanta.setAnalyticsLayer(window.userAnalytics)
  }

  if (Principles.testFeature('intercom')) {
    Analytics.createIntercomInstance({ window: window })
  }
}

const setDomReadyHandlers = () => {
  // domReady(setInitialWorkspace);
  domReady(injectGemColors)
  domReady(initAnalytics)
  domReady(setupWSListener)
  domReady(AdobePDFViewer.createInstance)
}

setDomReadyHandlers()

if (module.hot) {
  module.hot.accept(() => {
    console.info('Accepting module from HMR.')
  })
}

export default Frontend

// The Marionette codebase expects global `_` to refer to Underscore
// (specifically version 1.8.3, since the codebase is in maintenance mode and
// we don't update dependencies if we don't need to). This line ensures that
// if Universe has implicitly changed global `_` to lodash it's reset before
// exiting Universe setup.
//
// Note that for the monolith's frontend tests (built on the Karma test runner)
// `window._` may not exist at the time this line runs.
if (window._ && window._.VERSION !== '1.13.8') window._.noConflict()
